import { type Clip, type ClipAssets } from '@air/api/types';

import { type WorkspaceAgentAssetMentionItem } from '~/components/v2/components/workspace/workspace-agent-panel/mentions/types';

/** Structural minimum, so tests can pass a plain object instead of a full `Clip`. */
export type WorkspaceAgentAssetMentionSource = Pick<
  Clip,
  'id' | 'assetId' | 'title' | 'importedName' | 'ext' | 'type'
> & {
  /** Required on `ClipAssets`, but search rows for unprocessed clips omit it. */
  assets: Partial<Pick<ClipAssets, 'image'>>;
};

export const toWorkspaceAgentAssetMentionItem = (
  clip: WorkspaceAgentAssetMentionSource,
): WorkspaceAgentAssetMentionItem => ({
  assetId: clip.assetId,
  assetType: clip.type,
  ext: clip.ext,
  id: clip.id,
  kind: 'asset',
  thumbnailUrl: clip.assets.image || null,
  title: clip.title || clip.importedName || 'Untitled',
  /** A clip is a version. */
  versionId: clip.id,
});
